"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataDictionaryView = void 0;
const sonar_http_1 = require("@sonar-software/sonar-http");
const getDataDictionaryViewBase = (0, sonar_http_1.createGetEndpoint)(({ id }) => `/api/v3/data-dictionary/views/${id}`);
const getDataDictionaryView = (request) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const response = yield getDataDictionaryViewBase(request);
    if (response.data) {
        response.data.columns = atob((_a = response.data.columns) !== null && _a !== void 0 ? _a : '');
    }
    return response;
});
exports.getDataDictionaryView = getDataDictionaryView;
//# sourceMappingURL=getDataDictionaryView.js.map